<template>
    <div>
        <button type="button" class="ui small blue button" v-on:click="openPicker">
            <slot>Choose existing photo</slot>
        </button>
        <div class="ui large modal" ref="modal">
            <div class="header">
                Choose existing file
                <div class="path-row">
                    <strong>Path: </strong>
                    <ul class="breadcrumbs">
                        <li v-for="crumb in crumbs" v-on:click="getFolder(crumb.subpath)">{{crumb.crumb}}</li>
                    </ul>
                </div>
            </div>
            <div class="scrolling content">
                <div class="ui grid">
                    <div class="col-6" v-if="subfolders.length > 0">
                            <strong>Sub-folders</strong>
                            <ul class="clickable-list">
                                <li v-for="dir in subfolders" v-on:click="getSubFolder(dir)">{{dir}}</li>
                            </ul>
                    </div>
                    <div :class="(subfolders.length > 0 ? 'col-10' : 'col-16')">
                            <strong>Files</strong>
                            <p v-if="files.length === 0">No files found</p>
                            <ul v-if="files.length > 0" class="clickable-list imgs">
                                <li v-for="file in files" v-on:click="selectFile(file.name)">
                                    <img v-if="file.image" :src="'/' + path + '/' + file.name" :title="file.name + (file.width ? ' (' + file.width+ '×' +file.height+')':'')">
                                    <div class="non-image-file" v-if="!file.image"><i class="icon file outline"></i> {{file.name}}</div>
                                </li>
                            </ul>
                    </div>
                </div>
            </div>
            <div class="actions">
                <div class="ui cancel button">Cancel</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['folder', 'photo_only'],
        data: function () {
            return {
                path: '',
                crumbs: [],
                files: [],
                subfolders: []
            };
        },
        methods: {
            openPicker(){
                this.getFolder(this.folder);
                $(this.$refs['modal']).modal('show');
            },
            getSubFolder(folder){
                this.getFolder(this.crumbs[this.crumbs.length -1].subpath + folder);
            },
            getFolder(folder){
                if(folder !== this.path){
                    axios.get('/admin/api/uploads?folder='+folder+(this.photo_only?'&photo_only=true':''))
                        .then(function(response){
                            if(response.data){
                                this.path = response.data.path;
                                this.processPath();
                                this.files = response.data.files.map(function(file){return {name:file.name,image:file.image,height:null,width:null};});
                                this.subfolders = response.data.subfolders;
                                this.files.forEach(this.getImageSize);
                                Vue.nextTick(function(){$(this.$refs['modal']).modal('refresh');}.bind(this));
                            }
                        }.bind(this));
                }
            },
            getImageSize(file){
                if(file.image){
                    let image = new Image();
                    image.onload = function(){
                        file.width = image.naturalWidth;
                        file.height = image.naturalHeight;
                    };
                    image.src = '/'+this.path+'/'+file.name;
                }
            },
            processPath(){
                let crumbs = this.path.split('/');
                this.crumbs = [];
                crumbs.forEach(function(crumb, i, crumbs){
                    this.crumbs[i] = {crumb:crumb,subpath:crumbs.slice(1,i+1).join('/')};
                }, this)
            },
            selectFile(filename){
                this.$emit('picked','/'+this.path+'/', filename);
                $(this.$refs['modal']).modal('hide');
            }
        }
    }
</script>
<style scoped lang="scss">
    button.blue {
        margin-top: 1em;
    }
    .path-row {
        display: flex;
        flex-direction: row;
        font-size: 1rem;
    }
    ul {
        padding-left: 1em;
        list-style: none;
        margin: 0;
    }
    .breadcrumbs {
        display: flex;
        flex-direction: row;
        li {
            &:not(:last-of-type){
                cursor: pointer;
                text-decoration: underline;
            }
            &:not(:first-of-type):before{
                content: ' / ';
                font-weight: bold;
                margin-left: 1ch;
            }
        }
    }
    .clickable-list {
        li {
            cursor: pointer;
            text-decoration: underline;
        }
        &.imgs {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            li {
                text-decoration: none;
                margin-right: 0.5em;
                img {
                    height: 8em;
                }
                .non-image-file {
                    height: 8em;
                    border: 1px solid black;
                    border-radius: 5px;
                    padding: 0.5em;
                    display: flex;
                    flex-flow: column;
                    align-items: center;
                    i.icon {
                        font-size: 4em;
                        margin-bottom: 0.3em;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/admin/chooseExistingFile.vue